import type { User } from "firebase/auth";
import { createContext, useContext } from "react";
import type { UserContext } from "./auth";

interface AuthContext {
  readonly user: User | null;
  readonly context: UserContext | null;
}

export const AuthContext = createContext<AuthContext>({
  user: null,
  context: null,
});

export const useAuthContext = () => useContext(AuthContext);
